import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import SatCycleMonitorPanel from "@/components/disenador/SatCycleMonitorPanel";
import { Activity } from "lucide-react";

/**
 * Monitor primer ciclo SAT — plegable, inicia cerrado (solo lectura; no altera robot/colas).
 */
export default function SatCycleMonitorAccordion() {
  return (
    <Accordion
      type="single"
      collapsible
      className="rounded-sm border border-sky-200 bg-sky-50/30 shadow-sm"
      data-testid="designer-tools-sat-cycle-monitor-accordion"
    >
      <AccordionItem value="sat-cycle-monitor" className="border-0">
        <AccordionTrigger
          className="px-4 py-3 hover:no-underline"
          data-testid="designer-tools-sat-cycle-monitor-trigger"
        >
          <span className="flex items-center gap-2 text-sm font-semibold text-[#0F2D5C]">
            <Activity className="w-4 h-4 shrink-0 text-sky-700" aria-hidden />
            Monitor primer ciclo SAT (solo lectura)
          </span>
        </AccordionTrigger>
        <AccordionContent className="px-4 pb-4 pt-0 border-t border-sky-100">
          <SatCycleMonitorPanel embedded />
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  );
}
